<div class="d-flex flex-wrap" (window:resize)="ngAfterViewInit()">
  <ng-container *ngFor="let course of courses | excludeArchivedCourses; trackBy: courseId; ">
    <app-course-view-grid [course]="course"></app-course-view-grid>
  </ng-container>
</div>
